export default {
    LOAD_INSTRUCTOR_CONCEPT_DATA_SUCCESS: 'LOAD_INSTRUCTOR_CONCEPT_DATA_SUCCESS',
    LOAD_INSTRUCTOR_CONCEPT_DATA_FAILURE: 'LOAD_INSTRUCTOR_CONCEPT_DATA_FAILURE',

    ADD_INSTRUCTOR_CONCEPT_ELEM_REQUEST: 'ADD_INSTRUCTOR_CONCEPT_ELEM_REQUEST',
    ADD_INSTRUCTOR_CONCEPT_ELEM_PROGRESS: 'ADD_INSTRUCTOR_CONCEPT_ELEM_PROGRESS',
    ADD_INSTRUCTOR_CONCEPT_ELEM_SUCCESS: 'ADD_INSTRUCTOR_CONCEPT_ELEM_SUCCESS',
    ADD_INSTRUCTOR_CONCEPT_ELEM_FAILURE: 'ADD_INSTRUCTOR_CONCEPT_ELEM_FAILURE',
    RESET_ADD_INSTRUCTOR_CONCEPT_ELEM:'RESET_ADD_INSTRUCTOR_CONCEPT_ELEM',

    DEL_INSTRUCTOR_CONCEPT_ELEM_SUCCESS: 'DEL_INSTRUCTOR_CONCEPT_ELEM_SUCCESS',
    DEL_INSTRUCTOR_CONCEPT_ELEM_FAILURE: 'DEL_INSTRUCTOR_CONCEPT_ELEM_FAILURE',

    REO_INSTRUCTOR_CONCEPT_ELEM_SUCCESS: 'REO_INSTRUCTOR_CONCEPT_ELEM_SUCCESS',
    REO_INSTRUCTOR_CONCEPT_ELEM_FAILURE: 'REO_INSTRUCTOR_CONCEPT_ELEM_FAILURE',

    INFO_INSTRUCTOR_CONCEPT_ELEM_SUCCESS: 'INFO_INSTRUCTOR_CONCEPT_ELEM_SUCCESS',
    INFO_INSTRUCTOR_CONCEPT_ELEM_FAILURE: 'INFO_INSTRUCTOR_CONCEPT_ELEM_FAILURE',

    CREATE_QUESTION_MODULE: 'CREATE_QUESTION_MODULE',
    UPDATE_QUESTION_MODULE: 'UPDATE_QUESTION_MODULE',
    DELETE_QUESTION_MODULE: 'DELETE_QUESTION_MODULE',
    PUBLISH_QUESTION_MODULE: 'PUBLISH_QUESTION_MODULE',
    PUBLISH_ALL_QUESTIONS: 'PUBLISH_ALL_QUESTIONS',

    CREATE_QUESTION_REQUEST: 'CREATE_QUESTION_REQUEST',
    CREATE_QUESTION: 'CREATE_QUESTION',
    CREATE_QUESTION_SUCCESS: 'CREATE_QUESTION_SUCCESS',
    CREATE_QUESTION_STATUS_RESET: 'CREATE_QUESTION_STATUS_RESET',
    CREATE_QUESTION_FAILURE: 'CREATE_QUESTION_FAILURE',
    UPDATE_QUESTION: 'UPDATE_QUESTION',
    DELETE_QUESTION: 'DELETE_QUESTION',
    PUBLISH_QUESTION: 'PUBLISH_QUESTION',

    UPDATE_QUIZ: 'UPDATE_QUIZ',

}